import { GET_DISCLAIMERS } from "../actions";
import {IFilterRequest} from "../models";

export function disclaimerReducer(state: {} = {}, action) {
	switch (action.type) {
		case GET_DISCLAIMERS:
			return action["payload"] || {};
		default: return state;
	}
}


// WEBPACK FOOTER //
// ./src/client/reducers/disclaimers.ts